<template>
  <div class="tw-h-11 tw-bg-info-100 tw-rounded-full tw-py-2 tw-px-4 tw-leading-loose -tw-mb-6 tw-text-info tw-font-semibold tw-flex tw-items-center tw-space-x-2 tw-justify-center">
    <SvgVue
      icon="icons/airline-ticket"
      class="tw-h-6 tw-w-6"
    />
    <span>Coupon Applied</span>
  </div>
</template>
